"use client"

import { useState, useEffect } from "react"
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  TextField,
  Button,
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material"
import {
  Payment as PaymentIcon,
  Home as HomeIcon,
  CalendarToday as CalendarTodayIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  ExitToApp as ExitToAppIcon,
} from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import axios from "axios"

const baseUrl = process.env.REACT_APP_APP_URL

const Gestiondestock = () => {
  const navigate = useNavigate()
  const [quantity, setQuantity] = useState("") // État pour la quantité
  const [description, setDescription] = useState("") // État pour la description
  const [amount, setAmount] = useState("") // État pour le montant
  const [date, setDate] = useState("") // État pour la date
  const [status, setStatus] = useState("") // État pour le statut
  const [selectedItem, setSelectedItem] = useState("") // État pour les marchandises
  const [users, setUsers] = useState([]) // Liste des utilisateurs
  const [searchTerm, setSearchTerm] = useState("") // État pour la recherche
  const token = localStorage.getItem("CC_Token")

  useEffect(() => {
    // Fetch users from the API
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/users/members`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        if (Array.isArray(response.data.members)) {
          setUsers(response.data.members)
        } else {
          console.error("Invalid response format: users data is not an array")
          setUsers([])
        }
      } catch (error) {
        console.error("Error fetching users:", error)
        toast.error("Erreur lors de la récupération des utilisateurs.", {
          position: "top-right",
          autoClose: 3000,
        })
      }
    }
    fetchUsers()
  }, [token])

  const handlePaymentSubmit = async () => {
    // Validate required fields
    if (!selectedItem) {
      toast.error("Le champ 'Marchandise' est obligatoire.", {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    if (!quantity) {
      toast.error("Le champ 'Quantité' est obligatoire.", {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    if (!date) {
      toast.error("Le champ 'Date de transaction' est obligatoire.", {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    if (!status) {
      toast.error("Le champ 'Statut' est obligatoire.", {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    try {
      const data = {
        Marchandise: selectedItem,
        Quantité: Number.parseInt(quantity, 10),
        Description: description || null,
        Montant: amount ? Number.parseFloat(amount) : null,
        date: date,
        Statut: status,
      }

      const response = await axios.post(`${baseUrl}/api/stock`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })

      toast.success("Stock enregistré avec succès!", {
        position: "top-right",
        autoClose: 3000,
      })

      // Reset form fields
      setQuantity("")
      setDescription("")
      setAmount("")
      setDate("")
      setStatus("")
      setSelectedItem("")
    } catch (error) {
      console.error("Error submitting stock:", error)
      toast.error("Une erreur est survenue. Veuillez réessayer.", {
        position: "top-right",
        autoClose: 3000,
      })
    }
  }

  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs")
  }

  const handleLogout = () => {
    localStorage.removeItem("CC_Token")
    localStorage.removeItem("user")
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    })
    setTimeout(() => navigate("/login"), 4000)
  }

  const handleProfile = () => {
    navigate("/ProfileAdmin")
  }

  return (
    <div className="app">
      {/* Toast Container */}
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box
        sx={{
          padding: "1rem",
          backgroundColor: "#f8f8f8",
          borderRadius: "8px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: "600",
            textAlign: "center",
            color: "#333",
            marginBottom: "1.5rem",
          }}
        >
          Gestion de Stock
        </Typography>

        {/* Formulaire de Paiement */}
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
              <InputLabel>Marchandises</InputLabel>
              <Select
                value={selectedItem}
                onChange={(e) => setSelectedItem(e.target.value)}
                label="Marchandises"
                sx={{
                  backgroundColor: "#ffffff",
                  borderRadius: "5px",
                  padding: "6px 10px",
                  fontSize: "0.875rem",
                  height: "60px",
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      width: "100%",
                    },
                  },
                }}
              >
                {["Foins", "Paille", "Orge", "SNA Élevage", "SNA Sport", "SNA Entretien" , "Copeau de bois"].map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Quantité"
              variant="outlined"
              fullWidth
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "5px",
                marginBottom: "1rem",
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "5px",
                marginBottom: "1rem",
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Montant"
              variant="outlined"
              fullWidth
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "5px",
                marginBottom: "1rem",
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Date de transaction"
              type="date"
              variant="outlined"
              fullWidth
              value={date}
              onChange={(e) => setDate(e.target.value)}
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "5px",
                marginBottom: "1rem",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
              <InputLabel>Statut</InputLabel>
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                label="Statut"
                sx={{
                  backgroundColor: "#ffffff",
                  borderRadius: "5px",
                  padding: "6px 10px",
                  fontSize: "0.875rem",
                  height: "60px",
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      width: "100%",
                    },
                  },
                }}
              >
                {["IN", "OUT"].map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handlePaymentSubmit}
              fullWidth
              sx={{
                padding: "0.75rem",
                fontSize: "1rem",
                backgroundColor: "#004080",
                borderRadius: "5px",
              }}
            >
              Enregistrer Stock
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminChrono")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/Admin")}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminPaiment")}
          />
        </BottomNavigation>
      </Box>
    </div>
  )
}

export default Gestiondestock

